<template>
  <div>
    <v-dialog ref="dialog" v-model="modal" persistent width="300px">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="formattedTime"
          prepend-icon="mdi-clock-time-four-outline"
          readonly
          v-bind="attrs"
          v-on="on"
          :disabled="disabled"
        >
          <template v-slot:label>
            <span v-html="label"></span>
          </template>
        </v-text-field>
      </template>
      <v-time-picker
        v-model="internalTime"
        :allowed-hours="allowedHours"
        :allowed-minutes="allowedMinutes"
        full-width
        :format="format"
        :disabled="disabled"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="cancelSelection">Cancel</v-btn>
        <v-btn text color="primary" @click="saveSelection">OK</v-btn>
      </v-time-picker>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "TimePicker",
  props: {
    /**
     * The v-model prop for the time value
     */
    value: {
      type: String,
      default: "",
    },
    /**
     * The time format to be used in the picker.
     * - "ampm" for 12-hour format with AM/PM
     * - "24hr" for 24-hour format
     */
    format: {
      type: String,
      default: "24hr",
    },
    /**
     * Label for the time picker input field.
     */
    label: {
      type: String,
      default: "Pick a Time",
    },
    /**
     * Allowed hours for the time picker.
     */
    allowedHours: {
      type: [Function, Array],
      default: null,
    },
    /**
     * Allowed minutes for the time picker.
     */
    allowedMinutes: {
      type: [Function, Array],
      default: null,
    },
    /**
     * Disable time picker.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalTime: "",
      modal: false,
    };
  },
  computed: {
    /**
     * Format the displayed time based on the format prop.
     */
    formattedTime() {
      if (!this.internalTime) return "";
      if (this.format === "ampm") {
        return this.convertTo12HourFormat(this.internalTime);
      }
      return this.internalTime;
    },
  },
  watch: {
    /**
     * Sync the internalTime whenever parent value (v-model) changes
     */
    value: {
      immediate: true,
      handler(newValue) {
        this.internalTime = newValue;
      },
    },
  },
  methods: {
    /**
     * Save the selection, emit it to the parent component, and close the dialog
     */
    saveSelection() {
      this.modal = false;
      this.$emit("input", this.internalTime);
    },
    /**
     * Cancel the selection, reset to the parent-provided value, and close the dialog
     */
    cancelSelection() {
      this.modal = false;
      this.internalTime = this.value;
    },
    /**
     * Convert 24-hour time (HH:mm) to 12-hour format with AM/PM.
     */
    convertTo12HourFormat(time) {
      const [hours, minutes] = time.split(":").map(Number);
      const period = hours >= 12 ? "PM" : "AM";
      const formattedHours = hours % 12 || 12;
      return `${formattedHours}:${minutes
        .toString()
        .padStart(2, "0")} ${period}`;
    },
  },
};
</script>
